import React from 'react';
import { HexGrid, Layout, Hexagon } from 'react-hexgrid';
import './index.css';

const hexagons = [
    // diagonal inferior esquerda
    { q: 6, r: -10, s: 2 }, { q: 7, r: -10, s: 2 }, { q: 8, r: -11, s: 1 }, { q: 8, r: -12, s: 2 },
    { q: 9, r: -12, s: 2 },

    // coluna do meio
    { q: 10, r: -12, s: 2 }, { q: 10, r: -11, s: 1 }, { q: 10, r: -10, s: 0 }, { q: 10, r: -9, s: -1 },
    { q: 10, r: -7, s: -3 }, { q: 10, r: -6, s: -4 },

    //segunda coluna do meio
    { q: 9, r: -10, s: 2 }, { q: 9, r: -9, s: 1, isSpecial: true }, { q: 9, r: -8, s: 0 }, { q: 9, r: -7, s: -1 },

    { q: 8, r: -9, s: 1 }, { q: 8, r: -8, s: 0 }, { q: 8, r: -7, s: -1 },

    { q: 7, r: -7, s: 1 }, { q: 7, r: -6, s: 0 }, { q: 7, r: -5, s: -1 }, { q: 6, r: -6, s: 1 }, { q: 6, r: -4, s: -1 }, { q: 5, r: -4, s: -1 }, { q: 4, r: -3, s: -1 }
];

function Hexagons() {
    return (
        <div>
            <HexGrid width={800} height={800} viewBox="-50 -50 100 100">
                <Layout size={{ x: 2.5, y: 2.5 }} flat={true} spacing={1.3} origin={{ x: 0, y: 0 }}>
                    {hexagons.map(({ q, r, s, isSpecial }, idx) => (
                        <Hexagon
                            key={idx}
                            q={q}
                            r={r}
                            s={s}
                            style={{
                                fill: isSpecial ? '#FE5F2F' : '#ffffff',
                                strokeWidth: .5,
                                stroke: isSpecial ? '#FE5F2F' : '#ffffff'
                            }}
                            className='hexagon'
                        />
                    ))}
                </Layout>
            </HexGrid>
        </div>
    );
}

export default Hexagons;
